import { Misc, Network } from '@manifoldxyz/js-ts-utils';

const networkCheck = async (network: number): Promise<void> => {
  try {
    await window.ManifoldEthereumProvider.switchToChain(network);
    // Poll until the network actually changes or we timeout
    await Misc.poll({
      interval: 500, // 0.5 seconds
      maxAttempts: 20, // 10 seconds total
      fetch: async () => {
        const newChainId = await window.ManifoldEthereumProvider.chainId();
        return newChainId || -1;
      },
      validate: (chainId: number) => {
        return chainId === network;
      },
      errorMessage: `Failed to auto-switch to network ${Network.getDisplayNameForNetworkId(network)}. Please switch manually then try again.`,
    });
  } catch (error) {
    // Handle case where the network isn't added to their wallet yet
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((error as any).code === 4902) {
      // request to add network
      const provider = window.ManifoldEthereumProvider.provider();
      if (provider) {
        const networkConfigs = Network.NETWORK_CONFIGS[network as Network.NetworkId];
        if (networkConfigs) {
          const params = {
            chainId: `0x${network.toString(16)}`,
            chainName: networkConfigs.chainName,
            nativeCurrency: networkConfigs.nativeCurrency,
            rpcUrls: networkConfigs.rpcUrls,
            blockExplorerUrls: networkConfigs.blockExplorerUrls,
          };
          await provider.send('wallet_addEthereumChain', [params]);
          // try switching again
          await window.ManifoldEthereumProvider.switchToChain(network);
          return;
        }
      }
      throw new Error(
        `The ${Network.getDisplayNameForNetworkId(network)} network needs to be added to your wallet first`,
      );
    }

    if (error instanceof Error) {
      throw new Error(
        `Failed to switch to the ${Network.getDisplayNameForNetworkId(network)} network: ${error.message}`,
      );
    }

    throw new Error(
      `Failed to switch to the ${Network.getDisplayNameForNetworkId(network)} network`,
    );
  }
};

export default networkCheck;
